import React from "react";
import { cta } from "../../content/siteContent";
import { scrollToId } from "../../hooks/useLenis";
import { track, EVENTS } from "../../lib/analytics";

/* Sticky bottom CTA — mobile only. */
export const MobileStickyCTA = () => {
  const request = () => {
    track(EVENTS.PROSPECTUS_CTA, { location: "mobile-sticky" });
    scrollToId("prospectus");
  };
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-navy/95 backdrop-blur-lg border-t border-hair-dark p-3"
    >
      <button
        onClick={request}
        data-testid="mobile-sticky-prospectus"
        className="w-full bg-teal text-white font-display font-semibold text-sm rounded-sm py-3.5 focus-ring"
      >
        {cta.prospectus}
      </button>
    </div>
  );
};
